module.exports = __webpack_public_path__ + "static/media/sdk-shape.d0aebe3b.svg";